module.exports = __webpack_public_path__ + "images/erp-nation-glad-top-2026.1789440611829.png";